import React from 'react';
import classnames from 'classnames';
import { Badge } from 'reactstrap';

import { Intl } from 'components';

export default React.memo( ( { status } ) => (
  status
    ? (
      <h2 className="m-0">
        <Badge className={classnames( 'text-white text-capitalize px-3', {
          'bg-gray-5': status !== 'execution' && status !== 'finished' && status !== 'finishedError',
          'bg-purple-1': status === 'execution',
          'bg-success': status === 'finished',
          'bg-red-3': status === 'finishedError',
        } )}
        >
          <Intl id={status} />
        </Badge>
      </h2>
    ) : null
) );
